import { RequireAuth } from "@/components/auth/RequireAuth";
import { PageContentLoader } from "@/components/PageContentLoader";
import GarcomPage from "./GarcomPage";
import "../cardapio/cardapio.css";
import "./garcom.css";

export default function GarcomAuthPage() {
  return (
    <RequireAuth
      redirectTo="/garcom"
      loginTitle="Faça login para acessar o garçom"
      loadingFallback={
        <div className="garcom-loading-wrap">
          <PageContentLoader />
        </div>
      }
    >
      <GarcomPage />
    </RequireAuth>
  );
}
